import { ComponentProps, FC } from 'react';

import BaseSvg from '@/designSystem/Icon/Internal/BaseSvg';

export const IconTextUnderline: FC<ComponentProps<typeof BaseSvg>> = ({
  className = '',
}) => (
  <BaseSvg className={className}>
    <path d="M2 20V17.7778H18V20H2ZM10 15.5556C8.07619 15.5556 6.58095 14.9722 5.51429 13.8056C4.44762 12.6389 3.91429 11.0926 3.91429 9.16667V0H6.85714V9.33333C6.85714 10.3704 7.12381 11.213 7.65714 11.8611C8.19048 12.5093 8.97143 12.8333 10 12.8333C11.0286 12.8333 11.8095 12.5093 12.3429 11.8611C12.8762 11.213 13.1429 10.3704 13.1429 9.33333V0H16.0857V9.16667C16.0857 11.0926 15.5524 12.6389 14.4857 13.8056C13.419 14.9722 11.9238 15.5556 10 15.5556Z" />
  </BaseSvg>
);
